import React, { useState } from "react";
import { IconButton } from '@mui/material';
import { CgMoreVertical } from "react-icons/cg";
import { jsPDF } from "jspdf";
import Popup from 'reactjs-popup';
import SubflowTemplateServiceController from "../../Controllers/SubflowTemplateService";
import closeButton from '../../Assets/popup-close.svg';

const PopMenu = ({ menuOption, cloneClick, deleteClick, editClick, id, workflow, isPublished }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const subflowTempcont = new SubflowTemplateServiceController();

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const getImg = async () => {
    try {
      let base64Data = await subflowTempcont.getPreviewImg(id, workflow ? "Workflow" : "SubWorkflow");
      base64Data = base64Data.replace(/"/g, '');
      if (!base64Data || typeof base64Data !== 'string') {
        throw new Error('Invalid response format');
      }
      const cleanBase64 = base64Data.trim();
      const imageUrl = cleanBase64.startsWith('data:image/')
        ? cleanBase64
        : `data:image/jpeg;base64,${base64Data}`;

      const base64Pattern = /^data:image\/(jpeg|jpg|png|gif);base64,/;
      if (!base64Pattern.test(imageUrl)) {
        throw new Error('Invalid base64 image format');
      }

      return imageUrl;
    } catch (error) {
      console.error('Error loading image:', error);
      return closeButton;
    }
  };

  const downloadImage = () => {
    const dataUrl = localStorage.getItem('flowImage');
    if (dataUrl) {
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'react-flow.svg';
      link.click();
    } else {
      console.error('No image data found in local storage');
    }
  };

  const downloadPdf = async () => {
    try {
      const dataUrl = await getImg();
      if (dataUrl) {
        const img = new Image();
        img.src = dataUrl;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const pngDataUrl = canvas.toDataURL('image/jpg');
          const pdf = new jsPDF('p', 'pt', 'a4');

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const imgAspectRatio = img.width / img.height;

          let width, height;
          if (imgAspectRatio > 1) {
            width = pdfWidth;
            height = pdfWidth / imgAspectRatio;
          } else {
            height = pdfHeight;
            width = pdfHeight * imgAspectRatio;
          }

          const xOffset = (pdfWidth - width) / 2;
          const yOffset = (pdfHeight - height) / 2;

          pdf.addImage(pngDataUrl, 'JPG', xOffset, yOffset, width, height);
          pdf.save('react-flow-diagram.pdf');
        };
        img.onerror = (e) => {
          console.error('Image loading error', e);
        };
      } else {
        console.error('No image data found in local storage');
      }
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  };

  const downloadPdfFull = () => {
    const dataUrl = localStorage.getItem('flowImage');
    if (dataUrl) {
      const img = new Image();
      img.src = dataUrl;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const pngDataUrl = canvas.toDataURL('image/png');

        const pdf = new jsPDF('p', 'pt', 'a4');
        pdf.addImage(pngDataUrl, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
        pdf.save('react-flow-diagram.pdf');
      };
      img.onerror = (e) => {
        console.error('Image loading error', e);
      };
    } else {
      console.error('No image data found in local storage');
    }
  };

  return (
    <>
      <div>
        <Popup
          trigger={
            <IconButton onClick={handleClick}>
              <CgMoreVertical />
            </IconButton>
          }
          position="left top"
          offsetX={-20}
          offsetY={25}
        >
          <div
            style={{
              background: "#fff",
              border: "1px solid #121b45",
              offsetPosition: "left 10px top 10px",
            }}
          >
            <ul
              style={{
                listStyle: "none",
                cursor: "pointer",
                margin: 0,
                padding: 0,
              }}
            >
              {menuOption.map((menu, index) => {
                // Disable Edit and Delete if isPublished is true
                const isDisabled = isPublished && (menu === "Edit" || menu === "Delete");

                return (
                  <div key={menu + index}>
                    <li
                      style={{
                        fontSize: "15px",
                        fontFamily: "'Montserrat, sans-serif'",
                        fontWeight: "600",
                        color: isDisabled ? "#999" : "#121b45",
                        padding: "0px 5px",
                        position: "relative",
                        width: "130px",
                        height: "22px",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        userSelect: isDisabled ? "none" : "auto",
                      }}
                      onClick={() => {
                        if (isDisabled) return;
                        switch (menu) {
                          case "Download as image":
                            downloadImage();
                            break;
                          case "Download as pdf":
                            downloadPdf();
                            break;
                          case "Download pdf full page":
                            downloadPdfFull();
                            break;
                          case "Clone":
                            cloneClick(index);
                            break;
                          case "Delete":
                            deleteClick(index);
                            break;
                          case "Edit":
                            editClick(index);
                            break;
                          default:
                            break;
                        }
                      }}
                    >
                      {menu}
                    </li>
                    {index < menuOption.length - 1 && <hr />}
                  </div>
                );
              })}
            </ul>
          </div>
        </Popup>
      </div>
    </>
  );
};

export default PopMenu;
